const Strings = Object.freeze({
  // ---------------------------- Traffic Errors ----------------------------
  INPUT_ERRORS: "erros de entrada: ",
  OUTPUT_ERRORS: "erros de saída: ",

  CABLE_DELAY: "Cable delay",
  LINE_DELAY: "Line delay",
  DELAY_POPUP_1: "Indica dois diferentes atrasos de propagação (um ou outro, a depender da resposta do dispositivo).",
  DELAY_POPUP_2: "Variações nestes valores indicam problemas físicos na infraestrutura (cabeamento e conectores) e, no caso de “Line delay”, pode indicar problema nas interfaces de rede (transmissores e receptores).",
  DELAY_POPUP_3: "O valor indicativo máximo para o “Cable delay” é de 548 ns.",
  DELAY_POPUP_4: "Os diferentes atrasos indicados são:",
  DELAY_POPUP_5: "Atraso de propagação somente na parte cabeada;",
  DELAY_POPUP_6: "Inclui os atrasos do cabo, do transmissor e receptor Ethernet.",

  IN_ERRORS_POPUP: "Indica a soma de todos os pacotes recebidos com algum tipo de erro. Quando houver erros desse tipo sugere-se:",
  OUT_ERRORS_POPUP: "Indica a soma de todos os pacotes com algum tipo de erro que impediram a correta transmissão. Quando houver erros desse tipo sugere-se:",
  SOLVE_ERRORS_POPUP: "As sugestões de correção são indicadas na lista de ações. Para ter acesso, basta clicar no botão \"Exportar lista de ações\" na tela TS Expert.",

  TURN_ON: "ligar",
  TURN_OFF: "desligar",
  TURNED_ON_1: "ligado",
  MEASUREMENT_INTERVAL: "Período de medição",

  DUPLEX_MODE_POPUP: "Indica o modo Duplex da interface (Full ou Half Duplex) e a taxa de comunicação.",

  IN_PACKETS: "Pacotes de entrada",
  OUT_PACKETS: "Pacotes de saída",

  ARE_YOU_SURE_YOU_WANT: "Tem certeza que deseja ",
  THE_PORTS_FILTER: " o filtro de portas?",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN_CREDENTIALS_FAILURE: "Ocorreu um erro ao realizar o login: Nome de usuário ou senha incorretos.",
  LOGIN_GENERAL_FALIURE: "Ocorreu um erro ao realizar o login:",
  GPG_ALERT_MESSAGE: "Só é possível enviar arquivos com extensão .gpg",
  XML_ALERT_MESSAGE: "Só é possível enviar arquivos com extensão .xml",
  SEND_FILE_SUCCESS: "O arquivo foi enviado com sucesso.",
  SEND_FILES_SUCCESS: "Os arquivos foram enviados com sucesso.",
  SEND_FILE_SUCCESS_WARNING: "Não esqueça de verificar se a placa de rede do seu computador está na mesma subrede do IP: ",
  SEND_FILE_FAILURE: "Ocorreu um erro ao enviar o arquivo.",
  SEND_FILES_FAILURE: "Ocorreu um erro ao enviar os arquivos.",
  SEND_FILE_WAITING: "Enviando o arquivo.",
  SEND_FILES_WAITING: "Enviando os arquivos.",
  SEND_FILE_WRONG_FILENAME: "Nome inválido. O arquivo de atualização deve chamar-se: updatePN.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "O arquivo de atualização foi corrompido durante o envio.",
  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "Ocorreu um erro ao enviar os seguintes arquivos GSDML: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "Ocorreu um erro ao remover os seguintes arquivos GSDML: ",
  SEND_CONFIG_SUCCESS: "As configurações foram enviadas com sucesso.",
  SEND_CONFIG_FAILURE: "Ocorreu um erro ao enviar as configurações.",
  SEND_NTP_CONFIG_WAITING: "Enviando as configurações do servidor NTP.",
  SEND_NTP_CONFIG_DONE: "Configurações do servidor NTP enviadas.",

  SEND_CONFIG_WAITING: "Enviando as configurações.",
  SEND_CONFIG_WAITING_2: "Finalizando envio das configurações.",
  SEND_CONFIG_DONE: "Configurações enviadas.",
  SEND_WLAN_CONFIG_WAITING: "Enviando as configurações, por favor aguarde. Isso pode levar cerca de um minuto.",
  UPDATE_WLAN_CONFIG_ERROR: "Não foi possível conectar à rede WLAN. Caso o problema persista tente reiniciar o monitor ou o roteador WLAN.",
  UPDATE_OFFICE_INTERFACE_CONFIG_ERROR: "Erro ao configurar interface Office. Caso o problema persista tente reiniciar o monitor ou o roteador.",

  LOADING_WAITING: "Carregando informações, por favor aguarde.",

  START_MESSAGE_SUCCESS: "O monitor irá iniciar em 15 segundos.",
  START_MESSAGE_FAILURE: "Ocorreu um erro ao iniciar o monitor.",
  STOP_MESSAGE_SUCCESS: "O monitor irá parar em 15 segundos.",
  STOP_MESSAGE_FAILURE: "Ocorreu um erro ao parar o monitor.",
  WAITING: "Aguarde um instante",
  CLEAN_LOG_SUCCESS: "O log foi limpado com sucesso.",
  CLEAN_LOG_FAILURE: "Ocorreu um erro ao limpar o log.",
  RESET_TRAFFIC_SUCCESS: "Os valores serão zerados na próxima varredura.",
  RESET_TRAFFIC_FAILURE: "Ocorreu um erro ao zerar os incrementos de erro.",
  RESET_DEVICES_SUCCESS: "Os dados de devices foram limpados com sucesso.",
  RESET_DEVICES_FAILURE: "Ocorreu um erro ao limpar os dados de devices.",
  CHANGE_USERNAME_SUCCESS: "O Nome de usuário foi alterado com sucesso. Por favor realize o login novamente.",
  CHANGE_USERNAME_FAILURE: "Ocorreu um erro ao alterar o nome de usuário: ",
  USERNAME_TOO_SHORT: "O nome de usuário precisa conter pelo menos um caractere.",
  PASSWORD_MISSMATCH: "As senhas digitadas não coincidem",
  CHANGE_PASSWORD_SUCCESS: "A senha foi alterada com sucesso. Por favor realize o login novamente.",
  CHANGE_PASSWORD_FAILURE: "Ocorreu um erro ao alterar a senha: ",

  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique as seguintes informações:",
  INVALID_IP: "\n- O IP inserido é inválido",
  INVALID_SUBMASK: "\n- A máscara inserida é inválida",
  INVALID_GATEWAY: "\n- O gateway inserido é inválido",
  INVALID_DNS: "\n- O DNS inserido é inválido",
  LOOPBACK_IP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do monitor",
  LOOPBACK_IP_NTP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do servidor NTP",
  TAG_TOO_LONG: "\n- O tamanho da tag não pode ultrapassar 30 caracteres",
  EMPTY_WIFI_PWD: "\n- A senha da Wi-fi não pode ser vazia",
  SELECT_TIMEZONE: "\n- É necessário selecionar uma Timezone para configurar o servidor NTP",
  SAME_SUBNET_IP_1: "\n- O endereço IP da interface office não pode estar na mesma subrede da interface PROFINET.",
  SAME_SUBNET_IP_2: "\n- O endereço IP da interface PROFINET não pode estar na mesma subrede da interface office.",
  SUBNET_OVERLAP_OFFICE: "\n- O TS Monitor PROFINET detectou que existe sobreposição de endereços entre a subrede da interface PROFINET e a subrede da interface office. Por esse motivo não é possível configurar a interface office com o endereço IP e máscara escolhidos.",
  SUBNET_OVERLAP_PROFINET: "\n- O TS Monitor PROFINET detectou que existe sobreposição de endereços entre a subrede da interface PROFINET e a subrede da interface office. Por esse motivo não é possível configurar a interface PROFINET com o endereço IP e máscara escolhidos.",
  SUBNET_OVERLAP_WLAN: "\n- O TS Monitor PROFINET detectou que existe sobreposição de endereços entre a subrede da interface PROFINET e a subrede da WLAN. Por esse motivo não é possível configurar a WLAN com o endereço IP e máscara escolhidos.",
  SUBNET_OVERLAP_PROFINET_WLAN: "\n- O TS Monitor PROFINET detectou que existe sobreposição de endereços entre a subrede da interface PROFINET e a subrede da WLAN. Por esse motivo não é possível configurar a interface PROFINET com o endereço IP e máscara escolhidos.",
  ZERO_IP_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como IP do monitor",
  ZERO_IP_MASK_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como máscara da rede",
  BROADCAST_IP_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do monitor",
  NETWORK_IP_MSG: "\n- O IP da rede não pode ser utilizado como IP do monitor",
  BROADCAST_GATEWAY_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do gateway",
  NETWORK_GATEWAY_MSG: "\n- O IP da rede não pode ser utilizado como IP do gateway",

  MONITORING_ON: "Ligado",
  MONITORING_OFF: "Desligado",

  GENERATING_REPORT_WAITING: "Gerando relatório, por favor aguarde",

  ALTER_USERNAME: "ALTERAR USUÁRIO",
  ALTER_PASSWORD: "ALTERAR SENHA",

  SELECT_FILE: "Por favor selecione um arquivo para enviar",
  SELECT_AT_LEAST_ONE_FILE: "Por favor selecione ao menos um arquivo para enviar",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Por favor selecione ao menos um arquivo para remover",

  DO_NOT_CLOSE_THIS_TAB: "Deixe esta aba aberta para acompanhar a atualização.",
  UPDATING_MONITOR_FILES: "Atualizando arquivos no monitor. Por favor aguarde.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Arquivos atualizados, preparando para reiniciar o monitor.",
  RESTARTING_MONITOR_WAIT: "Reiniciando o monitor, aguarde alguns minutos.",
  UPDATE_SUCCESS: "A atualização foi realizada com sucesso!",
  UPDATE_ERROR_STRING: "Ocorreu o seguinte erro ao atualizar o monitor: ",

  SWEEP_POPUP_MSG: " Permite a configuração de varredura personalizada para até 5 subredes.",
  MONITORING_QUESTION_ICON_INFO: "Liga e desliga o envio e captura de mensagens de forma ativa. Quando desligado, o monitor não dispara mensagens, e não obtém dados.",
  DEVICE_SEARCH_QUESTION_ICON_INFO: "Seleciona busca de forma contínua (constante) ou única, para diminuir o envio de mensagens. No modo de busca única novos dispositivos que surgirem na rede não serão encontrados.",
  GSDML_QUESTION_ICON_INFO: "O carregamento dos arquivos GSDml no TS Monitor amplia consideravelmente a capacidade de diagnóstico dos ativos, possibilitando a interpretação de informações específicas do fabricante que só podem ser mostradas caso o monitor tenha estes arquivos carregados.",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique pelo menos um dos campos para atualizar as configurações de interface.",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique pelo menos um dos campos para atualizar as configurações WLAN.",

  TAG_WAS_CHANGED_SUCCESSFULLY: "A tag do monitor foi modificada com sucesso.",
  TAG_CHANGE_FAILURE: "Ocorreu um erro ao modificar a tag do monitor.",

  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nLembre-se de atualizar o endereço no navegador para: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "As configurações de interface foram atualizadas com sucesso!",
  UPDATE_WLAN_CONFIG_SUCCESS: "As configurações de WLAN foram atualizadas com sucesso!",
  UPDATE_OFFICE_INTERFACE_CONFIG_SUCCESS: "As configurações da interface office foram atualizadas com sucesso!",

  CONTINUOUS: "Contínua",
  UNIQUE: "Única",

  ALTER_MONITOR_CONFIG: "Tem certeza que deseja alterar as configurações do monitor?",
  RESTART_SYSTEM: " Reiniciar Sistema",
  CONFIRM_RESTART_SYSTEM: "Tem certeza que deseja reiniciar o sistema?",
  RESTART_SYSTEM_FAILURE: "Ocorreu um erro ao tentar reiniciar o sistema.",
  RESTART_SYSTEM_SUCCESS: "Pedido de reinicialização enviado com sucesso. Aguarde cerca de 3 minutos para que o sistema seja reiniciado completamente.",

  WI_FI: "Wi-fi",
  MANAGE: "Gerenciar",

  TAG_CONFIG: "Tag da rede",

  ETHERNET: "Ethernet",
  WLAN: "WLAN",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Ligar servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "Tem certeza que deseja ligar o servidor NTP? Para isso o monitor precisará ser reiniciado.",

  NTP_INFO_TURNED_ON_SUCCESS: "O servidor NTP foi ligado com sucesso.",
  NTP_INFO_TURNED_ON_FAILURE: "Ocorreu um erro ao ligar o servidor NTP.",
  TURN_ON_DATE: "\nO horário do servidor foi atualizado para: ",

  MONITOR_WILL_BE_RESTARTED: "\nO monitor será reiniciado agora,",
  MONITOR_RESTART_SUCCESS: "O monitor foi reiniciado com sucesso.",
  MONITOR_RESTART_FAILURE: "Ocorreu um erro ao reiniciar o monitor.",

  NTP_INFO_TURNED_OFF_SUCCESS: "O servidor NTP foi desligado com sucesso.",
  NTP_INFO_TURNED_OFF_FAILURE: "Ocorreu um erro ao desligar o servidor NTP.",
  TURN_OFF_DATE: "\nHorário de desligamento: ",
  NTP_INFO_FAILURE: "Falha ao sincronizar com o servidor. Caso o erro persista entre em contato com o administrador do servidor NTP.",

  PROCESSING_NTP_INIT: "Iniciando processamento das informações do servidor NTP.",
  PROCESSING_NTP_INFO: "Processando as informações do servidor NTP.",
  PROCESSED_NTP_INFO: "Informações do servidor NTP processadas.",
  PROCESSING_NTP_ERROR: "Ocorreu um erro ao enviar as informações para o servidor NTP. Verifique se o endereço IP do servidor está correto. Caso estiver, verifique também se o serviço de NTP está ligado e tente novamente.",

  ETHERNET_CONFIG_POPUP: "Campo de configuração da interface Ethernet conectada a rede industrial e utilizada pelo TS Monitor para captura de dados.",
  WLAN_CONFIG_POPUP: "Campo de configuração da interface sem fio, quando adaptador disponível, utilizada para supervisão e acesso Web aos dados do TS Monitor. Esta rede é isolada da rede Ethernet/Industrial.",
  OFFICE_CONFIG_POPUP: "Campo de configuração da interface Ethernet utilizada para supervisão e acesso Web aos dados do TS Monitor. Esta rede é isolada da rede Ethernet/Industrial.",
  BLACKLIST_CONFIG_POPUP: "Permite a exclusão de alguns serviços de coleta de dados do TS Monitor.",
  TS_EXPERT_CONFIG_POPUP: "Permite habilitar / desabilitar as não conformidades a serem informadas pela ferramenta.",

  ALTER: "Alterar",
  USER: "Usuário",
  NEW_PWD: "Nova senha",
  REPEAT_PWD: "Repetir senha",
  REASON_DP: "Motivo: ",
  TEST_NETWORK: "Rede de teste",
  EDIT: "Editar",
  SWEEP: "Varredura",
  DEVICE_SEARCH: "Busca por Dispositivos",
  SOFTWARE_UPDATE: "Atualização de Software",
  CURRENT_VERSION: "Versão atual: ",
  UPDATE: "Atualizar",
  GSDML_FILES: "Arquivos GSDML",
  SEND: "Enviar",
  CLEAR: "Limpar",
  TRAFFIC_ERROR_INCREMENT: "Incremento de erros no Tráfego",
  REPORT: "Relatório",
  ALTER_LOGIN: "Alterar login",
  INTERFACE_CONFIG: "Configurações de Interface",
  INTERFACE_PROFINET_CONFIG: "Configurações de Interface PROFINET",
  ENTER: "Entrar",

  SNMP_MODE: "Modo SNMP",
  SNMP_MODE_QUESTION_ICON_INFO_1: "Ao colocar o TS Monitor PROFINET na rede, se for detectado que alguns dispositivos não estão operando corretamente, é possível ativar o modo SNMP devagar.",
  SNMP_MODE_QUESTION_ICON_INFO_2: "Ativar este modo diminuirá consideravelmente a taxa de envio de perguntas SNMP, podendo solucionar o problema.",
  SNMP_MODE_FAST: "Rápido",
  SNMP_MODE_SLOW: "Devagar",
  SNMP_MODE_WAS_CHANGED_SUCCESSFULLY: "O modo SNMP foi alterado com sucesso.",
  SNMP_MODE_CHANGE_FAILURE: "Ocorreu um erro ao alterar o modo SNMP.",

  PROFINET_INTERFACE: "Interface PROFINET",
  OFFICE_INTERFACE: "Interface OFFICE",

  // ---------------------------- Sweep Page ----------------------------
  PERSONALIZED_SWEEP: "Varredura personalizada",

  SWEEP_ON: "Ligada",
  SWEEP_OFF: "Desligada",
  BANDS: "Faixas",

  FIRST_BAND: "1ª Faixa",
  SECOND_BAND: "2ª Faixa",
  THIRD_BAND: "3ª Faixa",
  FOURTH_BAND: "4ª Faixa",
  FIFTH_BAND: "5ª Faixa",

  BEGINNING: "Início",
  END: "Fim",

  ALERT_MESSAGE_PLACEHOLDER: "Os campos das seguintes faixas possuem problemas: ",

  FIRST_SUBNETWORK_ADDRESS_NOT_VALID: "\n - O endereço da 1ª faixa não é valido",
  FIRST_SUBNETWORK_START_LESS_THAN_FINISH: "\n - O endereço de início da 1ª faixa é maior ou igual ao fim",
  FIRST_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - A 1ª faixa possui campos não preenchidos",

  SECOND_SUBNETWORK_ADDRESS_NOT_VALID: "\n - O endereço da 2ª faixa não é valido",
  SECOND_SUBNETWORK_START_LESS_THAN_FINISH: "\n - O endereço de início da 2ª faixa é maior ou igual ao fim",
  SECOND_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - A 2ª faixa possui campos não preenchidos",

  THIRD_SUBNETWORK_ADDRESS_NOT_VALID: "\n - O endereço da 3ª faixa não é valido",
  THIRD_SUBNETWORK_START_LESS_THAN_FINISH: "\n - O endereço de início da 3ª faixa é maior ou igual ao fim",
  THIRD_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - A 3ª faixa possui campos não preenchidos",

  FOURTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - O endereço da 4ª faixa não é valido",
  FOURTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - O endereço de início da 4ª faixa é maior ou igual ao fim",
  FOURTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - A 4ª faixa possui campos não preenchidos",

  FIFTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - O endereço da 5ª faixa não é valido",
  FIFTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - O endereço de início da 5ª faixa é maior ou igual ao fim",
  FIFTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - A 5ª faixa possui campos não preenchidos",

  SWEEP_DATA_SENT_SUCCESSFULLY: "As configurações de varredura foram salvas com sucesso.",
  SWEEP_DATA_SENT_ERROR: "Ocorreu um erro ao salvar as configurações de varredura.",
  SPECIFY_AT_LEAST_ONE_SUBNETWORK: "É preciso especificar ao menos uma subrede para salvar a varredura personalizada.",

  UNABLE_TO_SAVE_CUSTOM_SWEEP: "Não é possível salvar a varredura personalizada pois:",
  _THE: "- A ",
  BAND_HAS_IPS_NOT_IN_SUBNETWORK: "ª faixa contém IPs que não estão na subrede do monitor",
  SENDING_DATA: "Enviando dados",

  // ---------------------------- PDF Report ----------------------------
  REPORT_EXPORT_NAME_PDF: "Relatório TS Monitor PROFINET.pdf",
  FINISHING: "Finalizando...",
  SAVE_REPORT: "Salvar relatório",

  PROJECT_NAME_1: "Nome do projeto",
  LOCATION_1: "Localização",
  COMPANY_NAME_1: "Nome da empresa",
  RESPONSIBLE_NAME: "Nome do responsável",
  ADDRESS: "Endereço",
  CITY: "Cidade",
  TEL: "Telefone",
  CLIENT_LOGO: "Logo do cliente",
  EMAIL: "E-mail",
  EXECUTING_COMPANY_LOGO: "Logo da empresa executora",

  GENERAL_INFO_TITLE: "1. Visão Geral",
  LIVE_LIST_TITLE: "2. Live List",
  TOPOLOGY_TITLE: "3. Topologia",
  TRAFFIC_INPUT_TITLE: "4. Erros no tráfego de entrada",
  TRAFFIC_OUTPUT_TITLE: "5. Erros no tráfego de saída",
  LOG_PAGE_TITLE: "6. Log de eventos",

  ACTIVE_TYPE: "ATIVOS",
  NOT_ACTIVE_TYPE: "DESAPARECIDOS",

  CONFORM_STRING: "Conforme",
  CONFORM_W_RESTRICTION_STRING: "Conforme com restrições",
  NON_CONFORM_STRING: "Não conforme",

  GENERATING_REPORT_SUCCESS: "Relatório gerado com sucesso. Para salvá-lo, clique em salvar relatório abaixo.",

  CONFORMITY: "Conformidade",
  DROPDOWN_PLACEHOLDER: "Escolha uma opção",
  GENERATE_REPORT: "Gerar relatório",
  CLIENT_INFO: "Informações do cliente",
  EXECUTING_COMPANY_INFO: "Informações da empresa executora",
  ANNOTATIONS: "Anotações",
  CONCLUSION: "Conclusão",

  HEADER_TEXT: "Relatório de dados - TS Monitor PROFINET",
  REPORT_EXPORT_NAME: "Relatório TS Monitor PROFINET",

  GENERAL_REPORT: "Relatório geral – TS Monitor PROFINET",
  DATA_REPORT: "Relatório de dados – TS Monitor PROFINET",

  PROJECT_NAME: "- Nome do projeto:",
  NETWORK_NAME: "- Nome da rede:",
  LOCATION: "- Localização:",
  COMPANY_NAME: "- Nome da empresa:",
  ACCOUNTABLE_NAME: "- Nome do responsável:",
  COMPANY_ADDRESS: "- Endereço:",
  COMPANY_CITY: "- Cidade:",
  COMPANY_TEL: "- Telefone:",

  EXECUTING_COMPANY_NAME: "- Nome da empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nome do responsável:",
  EXECUTING_TEL: "- Telefone:",
  EXECUTING_EMAIL: "- Email:",

  MONITORING_INFO: "Informações do monitoramento",
  ETHERNET_INFO: "Informações ETHERNET",
  WLAN_INFO: "Informações WLAN",
  ETHERNET_OFFICE_INFO: "Informações ETHERNET Office",

  NETWORK_TAG_DP: "- Tag da rede: ",
  NETWORK_NAME_DP: "- Nome da rede: ",
  MONITOR_IP_DP: "- IP do monitor: ",
  MONITOR_SUBMASK_DP: "- Máscara do monitor: ",
  MONITOR_VERSION_DP: "- Versão do monitor: ",
  MONITOR_TIME_ON_DP: "- Tempo ligado: ",
  MEASUREMENT_INTERVAL_DP: "- Período de medição: ",
  REPORT_GENERATION: "- Geração do relatório: ",

  IP_DP: "- IP: ",
  MASK_DP: "- Máscara: ",
  GATEWAY_DP: "- Gateway: ",
  DNS_DP: "- DNS: ",
  MODO_DP: "- Modo de configuração: ",

  SUMMARY: "Sumário",
  OVERVIEW: "Visão Geral",
  LIVE_LIST: "Live List",
  INVENTORY: "Inventário",
  TOPOLOGY: "Topologia",
  GRAPHIC_TOPOLOGY: "Topologia gráfica",
  IN_TRAFFIC_ERRORS: "Erros no tráfego de entrada",
  OUT_TRAFFIC_ERRORS: "Erros no tráfego de saída",
  LOG: "Log",
  CONFIG: "Configurações",
  DISCLAIMER: "Aviso legal",

  M_MONITORING_OVERVIEW_PAGE_TITLE: "1. - Visão Geral",
  M_MONITORING_LIVE_LIST_PAGE_TITLE: "2. - Live List",
  M_MONITORING_INVENTORY_PAGE_TITLE: "3. - Inventário",
  M_MONITORING_TOPOLOGY_PAGE_TITLE: "4. - Topologia",
  M_MONITORING_IN_TRAFFIC_ERRORS_PAGE_TITLE: "5. - Erros no tráfego de entrada",
  M_MONITORING_OUT_TRAFFIC_ERRORS_PAGE_TITLE: "6. - Erros no tráfego de saída",
  M_MONITORING_LOG_PAGE_TITLE: "7. - Log de eventos",

  TS_MONITOR_VER_DP: "TS Monitor PROFINET - Versão ",
  NETWORK_STATUS_DP: "Estado da rede: ",
  DEVICE_DATA: "Dados dos dispositivos",

  CONTROLLERS_DP: "IO Controllers: ",
  DEVICES_DP: "IO Devices: ",
  SUPERVISORS_DP: "Supervisores: ",
  SUPERVISORS: "Supervisores",
  OTHER_DEVICES_DP: "Não PROFINET: ",
  OTHER_DEVICES: "Não PROFINET",
  FAULTS_DP: "Falhas: ",
  ALARMS_DP: "Alarmes: ",
  IN_TRAFFIC_DP: "Tráfego ethernet de entrada: ",
  OUT_TRAFFIC_DP: "Tráfego ethernet de saída: ",
  NETWORK_AVAILABILITY_DP: "Disponibilidade da rede: ",

  NAME: "Nome",
  MODEL: "Modelo",
  MAC: "MAC",
  MACS: "MACs",
  IP: "IP",
  IPS: "IPs",
  FUNCTION: "Função",
  STATUS: "Status",
  ON_TIME: "Tempo ligado",
  EVENT_TYPE: "Tipo de evento",

  MONITORING_BLACKLIST_STRING: "Blacklist de monitoramento",
  MONITORING_BLACKLIST_STRING_1: "Blacklist de",
  MONITORING_BLACKLIST_STRING_2: "monitoramento",
  OFFLINE_STRING: "Offline",
  ONLINE_STRING: "Online",
  FAULT_STRING: "Falha",
  DUPLICATE_IP_STRING: "IP duplicado",
  CONFIG_ERROR_STRING: "Erro de configuração",

  BLACKLIST_OK_STRING: "Blacklist - OK",
  BLACKLIST_ALARM_STRING: "Blacklist - Alarme",
  BLACKLIST_OFFLINE_STRING: "Blacklist - Offline",
  BLACKLIST_ONLINE_STRING: "Blacklist - Online",
  BLACKLIST_FAULT_STRING: "Blacklist - Falha",
  BLACKLIST_DUPLICATE_IP_STRING: "Blacklist - IP duplicado",
  BLACKLIST_CONFIG_ERROR_STRING: "Blacklist - Erro de configuração",

  SNMP: "SNMP",
  PORT: "Porta",
  NEIGHBOUR_NAME: "Nome vizinho",
  NEIGHBOUR_PORT_1: "Porta",
  NEIGHBOUR_PORT_2: "vizinho",
  NEIGHBOUR_IP: "IP vizinho",

  LAST_200_EVENTS: "200 últimos eventos",
  DESCRIPTION: "Descrição",
  HORARY: "Horário",

  END_OF_REPORT: "Fim do relatório",
  DISCLAIMER_TEXT: "Os dados e valores apresentados neste relatório são meramente auxiliares para o especialista em PROFINET, de tal sorte que qualquer indicação de correção deve ser feita pelo usuário. Por esta razão, recomenda-se acompanhamento de engenheiro certificado PROFINET ou técnico responsável pela análise para atestar as informações prestadas pelo produto. Portanto a Toledo & Souza se exime de quaisquer responsabilidades, perdas ou danos, diretos ou indiretos causados pelas interpretações do software, não oferecendo nenhuma garantia em relação à integridade, qualidade ou adequação das informações prestadas, pois dependem da análise técnica de um profissional capacitado, sendo que na falta deste, o usuário assumirá o risco de que o conteúdo possa ser impreciso, incompleto ou possa não atender às suas necessidades e requisitos.",

  NO_INPUT_TRAFFIC_ERRORS: "A rede não possui erros no tráfego de entrada",
  NO_OUTPUT_TRAFFIC_ERRORS: "A rede não possui erros no tráfego de saída",

  DEVICE_HAS_JOINED_THE_NETWORK: "O dispositivo entrou na rede",
  DETAILS: "Detalhes:",

  PAGE: "Página",
  INPUT: "Entrada",
  OUTPUT: "Saída",
  ERRORS_IN: "Erros na",
  PORT_STATUS: "Status da porta",
  REPORTING: " reportando:",
  TIP: "Dica:",
  THE_DEVICE: "O dispositivo",
  OF_IP: "de IP",
  JOINED_THE_NETWORK: "entrou na rede.",
  THE_PORT: "A porta",
  IS_CONNECTED_WITH_PORT: "dele está conectada à porta",
  FROM_DEVICE: "do dispositivo",

  // ---------------------------- Alarms ----------------------------
  ACTIVE_DP: "Ativos:",
  NOT_ACTIVE_DP: "Desaparecidos:",
  ALARM: "Alarme",
  ALARMS: "Alarmes",

  // ---------------------------- OTHERS ----------------------------
  BEFORE_MONITOR_INIT_STR: "Anterior à última inicialização",
  REMOVE_DEVICE_SUCCESS: "O dispositivo será removido em até 30 segundos.",
  REMOVE_DEVICE_FAILURE: "Ocorreu um erro ao remover o dispositivo: ",

  OK_STRING: "OK",
  WITH_DIAGNOSTIC_STRING: "Com alarme",
  WITH_FAILURE_STRING: "Com falha",
  UNKNOWN: "Desconhecido",
  NO_ANSWER: "Sem resposta",
  NO_EVENT: "Nenhum evento",
  LOG_WAITING: "Carregando dados do log",
  GO_TO_LOG_OR_REMOVE_POSITIONING: "Ir para log ou excluir device",
  ASK_DELETE_OR_LOG: "Deseja ir para a página de log ou excluir o device da lista?",
  DELETE: "Excluir",
  GO_TO_LOG: " Ir para log",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, MAC, nome, ou status",
  TOPOLOGY_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, nome ou modelo",
  TRAFFIC_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP ou nome",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por nome, modelo ou IP",
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Pesquisar por IP, Tag ou profiname",
  PING_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP ou MAC",
  FAULTS: "Falhas",
  ACTUAL_MEDIUM: "Atual / Médio",
  AVAILABILITY: "Disponibilidade",
  STATISTICS: "Estatísticas",
  BILLIONS_OF: "Bilhões de",
  ONE_MILLION_OF: "Milhão de",
  ONE_BILLION_OF: "Bilhão de",
  MILLIONS_OF: "Milhões de",
  THOUSAND: "Mil",
  THOUSAND_NO_CAPITAL: " mil",
  MILLION_NO_CAPITAL: " milhão",
  MILLIONS_NO_CAPITAL: " milhões",
  BILLION_NO_CAPITAL: " bilhão",
  BILLIONS_NO_CAPITAL: " bilhões",
  LAST_EVENT: "Último evento: ",
  UP_TIME: "Tempo ligado:",
  MONITORING: "Monitoramento: ",
  TURNED_OFF: "Desligado ",
  TURNED_ON: "Ligado ",
  MONITORING_ON_TOOLTIP: "Serviço de monitoramento ligado.",
  MONITORING_OFF_TOOLTIP: "Serviço de monitoramento desligado. Para ligar o serviço acesse a janela MONITORAMENTO dentro da aba de Configurações.",
  MONITORING_GETTING_CONNECTION: "Estabelecendo conexão.",
  ZERO_IP: "0.0.0.0",

  ALARMS_QUESTION_INFO: "Indica o número de alarmes respondidos pelos dispositivos. Alarmes indicam condições anormais de estado do dispositivo, como curto-circuito, problema de alimentação, falta de módulo, etc.",
  FAULTS_QUESTION_INFO: "Indica o número vezes que determinado dispositivo PROFINET não respondeu ao envio de mensagens pelo TS Monitor.",

  AVAILABILITY_QUESTION_INFO_1: "Indica o percentual de tempo cujo dispositivo foi detectado na rede, ou seja, estava acessível via rede.",
  AVAILABILITY_QUESTION_INFO_2: "Este parâmetro não leva em conta quaisquer outras condições como se o dispositivo estava funcionando ou não, mas sim o fato de responder ao TS Monitor.",

  SHOW_ONLY_ERROR_DEVICES: "Mostrar apenas dispositivos com erros",

  PORTS_FILTER_LABEL: "Filtro de portas",
  PORTS_FILTER_POPUP_1: "Alguns dispositivos apresentam perdas de pacote em portas internas para as quais não há ação corretiva possível pelo usuário, e não trazem informação relevante para análise da rede em si.",
  PORTS_FILTER_POPUP_2: "O filtro elimina estas portas, porém, portas com nomes incomuns podem ser eliminadas e, por este motivo, o filtro pode ser desligado a fim de permitir a visualização completa.",

  PORTS_FILTER_TURN_ON_FAILURE: "Ocorreu um erro ao ligar o filtro de portas.",
  PORTS_FILTER_TURN_OFF_FAILURE: "Ocorreu um erro ao desligar o filtro de portas.",

  DEVICE: "Dispositivo",

  LIVE_LIST_OK_POPUP_TEXT: "Dispositivo em operação normal, ou seja, em troca de dados.",
  LIVE_LIST_DIAGNOSTIC_POPUP_TEXT: "Dispositivo em modo de operação normal sinalizou uma condição de diagnóstico.",
  LIVE_LIST_FAULT_POPUP_TEXT: "Dispositivo que esteve em modo de operação normal (OK) não está mais comunicando na rede PROFINET, está, portanto, em falha.",
  LIVE_LIST_ONLINE_POPUP_TEXT: "Dispositivo está fisicamente na rede PROFINET e não troca dados com controlador. Este comportamento de deve ao fato de o dispositivo não estar ativo ou configurado no projeto do IO Controller.",
  LIVE_LIST_OFFLINE_POPUP_TEXT: "Device Ethernet que foi desconectado da rede.",
  LIVE_LIST_DUPLICATE_IP_POPUP_TEXT: "Quando mais de um device tem o mesmo endereço IP.",
  LIVE_LIST_DUPLICATE_IP_POPUP_TEXT_2: "Ao clicar na célula é possível excluir o dispositivo, caso queira.",
  LIVE_LIST_BLACKLIST_POPUP_TEXT: "O usuário pode colocar um IO Device em modo Blacklist, com o intuito de não gerar eventos repetitivos no Log.",
  LIVE_LIST_CONFIG_ERROR_POPUP_TEXT: "Dispositivo com ID numbers diferentes entre um módulo configurado e o instalado fisicamente (informação retirada do GSDml do dispositivo). A descrição é apresentada no log com mais detalhes.",

  LIVE_LIST_CSV_HEADER: "Nome,Tag,MAC,IP,Alarmes,Falhas,Ping atual (ms),Ping médio (ms),Pings perdidos,Pings perdidos (%),Disponibilidade,Status\n",
  LIVE_LIST_CSV_EXPORT_NAME: "Live List.xlsx",

  PS: "OBS:",

  IP_POPUP_2: "Caso o dispositivo perca seu endereço IP, ele terá fundo laranja, como no exemplo abaixo.",
  IP_POPUP_3: "Além disso, ao clicar na célula é possível excluir o dispositivo, caso queira.",

  REMOVE_LOST_IP_MODAL_HEADER: "Excluir dispositivo com perda de endereço IP",
  REMOVE_LOST_IP_MODAL_CONTENT_1: "Tem certeza que deseja excluir o dispositivo de endereço IP: 0.0.0.0?",
  REMOVE_LOST_IP_MODAL_CONTENT_2: "Caso o dispositivio ainda apresente perda de endereço IP, ele será adicionado novamente à Live List no próximo ciclo de buscas do TS Monitor PROFINET.",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  SAVE_TOPOLOGY_POS_STRING: "Salvar",
  DELETE_TOPOLOGY_POS_STRING: "Remover",
  EXPORT_SVG: "SVG",
  EXPORT_TOPOLOGY: "Topologia",
  IMPORT_TOPOLOGY: "Importar Topologia",
  IMPORT: "Importar",
  EXPORT_PNG: "PNG",
  POSITION: "Posição",
  EXPORT: "Exportar",
  FILTER: "Filtros",
  EXPORT_SVG_POPUP_MSG_1: "Para exportar a imagem da topologia no formato SVG é necessário primeiro salvar a posição da topologia.",
  EXPORT_SVG_POPUP_MSG_2: "Para exportar a imagem da topologia no formato SVG é necessário primeiro salvar a posição da topologia, como mostra a imagem abaixo:",
  EXPORT_SVG_POPUP_MSG_3: "Antes de clicar no botão SVG tenha certeza que todos os dispositivos da rede estão aparecendo dentro do retângulo, como mostra a figura abaixo:",
  EXPORT_SVG_POPUP_MSG_4: "Caso algum dispositivo esteja fora da área de visualização, como mostra a figura seguinte, ele não aparecerá no arquivo SVG:",

  HIGHER_THAN_20_MBPS: "> 20 Mbps",
  HIGHER_THAN_50_MBPS: "> 50 Mbps",
  WITH_ERROR: "Com erro",
  WITH_ERROR_INCREMENT: "Com &Delta; erro",
  LEGEND: "Legenda",

  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "O posicionamento da topologia foi salvo com sucesso!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "Ocorreu o seguinte erro ao salvar o posicionamento da topologia: ",

  DROP_TOPOLOGY_POS_SUCCESS_STRING: "O posicionamento da topologia foi removido com sucesso!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "Ocorreu o seguinte erro ao remover o posicionamento da topologia: ",

  DROPDOWN_NONE: "Nenhum",
  DROPDOWN_TRAFFIC: "Tráfego",
  DROPDOWN_ERRORS: "Erros",

  ASK_REMOVE_POSITIONING: "Tem certeza que deseja remover o posicionamento salvo? Para confirmar a remoção é necessário inserir as informações de login.",
  REMOVE_POSITIONING: "Remover posicionamento",
  GRAPHIC_TOPOLOGY_WAITING: "Carregando a topologia gráfica",
  YES: "Sim",
  NO: "Não",
  USERNAME_PWD_EMPTY: "O nome de usuário e senha não podem estar em branco.",

  FORM_INPUT_NOT_FOUND_1: "O device de IP: ",
  FORM_INPUT_NOT_FOUND_2: " não foi encontrado",
  FORM_INPUT_INVALID_IP: "Digite um endereço de ip valido",

  DUPLICATE_IPS: "Não foi possível carregar a topologia gráfica, pois a rede contém IPs duplicados.",

  DISCONNECTED_PORT_1: "A porta selecionada ",
  DISCONNECTED_PORT_2: " do dispositivo ",
  DISCONNECTED_PORT_3: " não está mais conectada a ninguém.",

  TOPOLOGY_IMPORT_SUCCESS: "A topologia foi importada com sucesso!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "Ocorreu um erro ao importar a topologia gráfica: ",
  INVALID_OR_CORRUPT_FILE: "O arquivo não é válido ou está corrompido.",
  PLEASE_SELECT_TOPOLOGY_FILE: "Por favor selecione um arquivo de topologia.",

  GRAPHIC_TOPOLOGY_POPUP_1: "A topologia gráfica é detectada automaticamente conforme informação recebida dos dispositivos da rede e apresenta o status do equipamento conforme as cores da LiveList e os links entre os dispositivos mudam de cor azul para laranja quando apresentam incremento de erro.",
  GRAPHIC_TOPOLOGY_POPUP_2: "Alguns equipamentos não respondem a comandos SNMP utilizados para esta detecção, assim, nem todos os equipamentos apresentados na LiveList estarão presentes na topologia gráfica.",
  GRAPHIC_TOPOLOGY_POPUP_3: "Os diferentes ícones apresentados dependem da inclusão dos arquivos de configuração GSDml na aba de configurações do TS Monitor (este arquivo deve corresponder ao dispositivo presente na rede, caso contrário não aparecerá o ícone correspondente ao tipo).",
  GRAPHIC_TOPOLOGY_POPUP_4: "As posições dos equipamentos podem ser alteradas, porém não é possível alterar a conexão entre eles ou adicionar equipamentos.",

  NAME_DP: "Nome: ",
  MODEL_DP: "Modelo: ",
  PROFINET_TOPOLOGY_JSON: "Topologia PROFINET.json",

  // ---------------------------- Log ----------------------------
  ALARM_FAILURE_TOOLTIP: "Manutenção deve ser realizada agora. O dispositivo não está mais funcionando.",
  ALARM_MAINTENANCE_DEMANDED_TOOLTIP: "Manutenção deve ser realizada assim que possível.",
  ALARM_MAINTENANCE_REQUIRED_TOOLTIP: "O dispositivo requer manutenção preditiva.",
  ALARM_NONE_TOOLTIP: "Severidade não informada.",
  INSERT_VALID_EVENT_OR_NAME_OR_IP: "Favor digite um evento, nome ou IP válidos.",
  MANUFACTURER_TIP: " (Dica do fabricante: ",
  FROM_GSDML: "Do GSDML: ",
  STATUS_CHANGE: "Mudança de estado: ",
  DUPLICATE_IP: "IP duplicado: ",
  DUPLICATE_NAME_DP: "Profiname duplicado: ",

  // ---------------------------- BLACKLIST ----------------------------
  UPDATE_BLACKLIST_DEVICES: "Atualizar dispositivos da blacklist",
  CONFIRM_UPDATE_BLACKLIST_MODAL_TEXT: "Tem certeza que deseja atualizar os dispositivos da blacklist?",

  ADD_DEVICES_TO_BLACKLIST: "Adicionar dispositivos à blacklist",
  REMOVE_DEVICES_FROM_BLACKLIST: "Remover dispositivos da blacklist",
  BLACKLIST_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por nome, MAC ou IP",
  BLACKLIST_NAME: "Nome",
  BLACKLIST_MODEL: "Modelo",
  BLACKLIST_MAC: "MAC",
  BLACKLIST_IP: "IP",
  SELECT_ALL: "Selecionar todos",
  REMOVE_SELECTED: "Remover selecionados",
  ADD_SELECTED: "Adicionar selecionados",
  ADD_DEVICES_TO_BLACKLIST_SUCCESS: "Os dispositivos foram adicionados à blacklist com sucesso.",
  ADD_DEVICES_TO_BLACKLIST_FAILURE: "Ocorreu um erro ao adicionar os seguintes dispositivos à blacklist:",
  REMOVE_DEVICES_FROM_BLACKLIST_SUCCESS: "Os dispositivos foram removidos da blacklist com sucesso.",
  REMOVE_DEVICES_FROM_BLACKLIST_FAILURE: "Ocorreu um erro ao remover os seguintes dispositivos da blacklist:",
  SELECT_AT_LEAST_ONE_DEVICE: "Selecione ao menos um dispositivo para adicionar à blacklist.",
  CONFIRM_ADD_TO_BLACKLIST_MODAL_TEXT: "Tem certeza que deseja adicionar os dispositivos selecionados à blacklist?",
  CONFIRM_REMOVE_FROM_BLACKLIST_MODAL_TEXT: "Tem certeza que deseja remover os dispositivos selecionados da blacklist?",
  IGNORE: "Ignorar",
  LOG_IGNORE: "Log",
  QUESTION_IGNORE: "Monitoramento",
  FAULTS_IGNORE: "Falhas",
  ALARMS_IGNORE: "Alarmes",
  AVAILABILITY_IGNORE: "Disponibilidade",
  SNMP_IGNORE: "SNMP",

  UPDATE_BLACKLIST: "Atualizar blacklist",
  UPDATING_BLACKLIST_WAITING: "Atualizando a blacklist, aguarde um instante",
  UPDATING_BLACKLIST_SUCCESS: "A blacklist foi atualizada com sucesso",
  BLACKLIST: "Blacklist",

  WHAT_DOES: "O que faz: ",
  HOW_DOES_IT_APPLY: "Como se aplica: ",

  DELTA_ERRORS_TOOLTIP_WHAT: "Não verifica no TS Expert se este dispositivo possui incremento de erros, mas continua contabilizando na aba tráfego.",
  DELTA_ERRORS_TOOLTIP_HOW: "Útil para RFIDs, Access Points e dispositivos com perdas de dados intrínsecas.",

  LOG_TOOLTIP_WHAT: "Contabiliza alarmes e falhas, porém não insere no log.",
  LOG_TOOLTIP_HOW: "Dispositivos que apresentam condições anormais que não podem ser resolvidas.",

  MONITORING_TOOLTIP_WHAT: "Não envia nenhum tipo de pergunta ao dispositivo.",
  MONITORING_TOOLTIP_HOW: "Alguns dispositivos podem apresentar comportamento anormal para sistemas de monitoramento contínuo e podem apresentar falhas.",

  FAULTS_TOOLTIP_WHAT: "Não verifica no TS Expert se este dispositivo possui Falhas, mas segue logando e contabilizando nas abas LiveList e Log.",
  FAULTS_TOOLTIP_HOW: "Comumente utilizado em dispositivos que apresentam alarmes normais durante o processo, como casos de AGVs e outros dispositivos que utilizam fast startup.",

  ALARMS_TOOLTIP_WHAT: "Não verifica no TS Expert se este dispositivo possui Alarmes, mas segue logando e contabilizando nas abas LiveList e Log.",
  ALARMS_TOOLTIP_HOW: "Comumente utilizado em dispositivos que apresentam alarmes normais durante o processo, como casos de AGVs e outros dispositivos que utilizam fast startup.",

  AVAILABILITY_TOOLTIP_WHAT: "Desconsidera o dispositivo para cálculo de disponibilidade.",
  AVAILABILITY_TOOLTIP_HOW: "Pode ser utilizado para dispositivos PROFINET e Ethernet levando em conta a criticidade do dispositivo ao processo.",

  SNMP_TOOLTIP_WHAT: "Diminui consideravelmente o envio de perguntas SNMP ao dispositivo.",
  SNMP_TOOLTIP_HOW_1: "Existem casos em que dispositivos com baixa taxa de processamento ficam sobrecarregados ao responder perguntas SNMP.",
  SNMP_TOOLTIP_HOW_2: "Ao colocar o TS Monitor PROFINET na rede, se for detectado que algum dispositivo não está operando corretamente, adicioná-lo a esta blacklist diminuirá consideravelmente a taxa de envio de perguntas SNMP, podendo solucionar o problema.",

  BLACKLIST_UPDATE_ERROR: "Ocorreu um erro ao salvar as informações da blacklist, por favor tente novamente",
  BLACKLIST_UPDATE_SUCCESS: "Blacklist atualizada com sucesso",

  REQUEST_TOOK_TOO_LONG: "A conexão demorou demais para responder.\n",
  UNABLE_TO_UPDATE_FOLLOWING_BLACKLISTS: "Não foi possível atualizar as informações das blacklists de:\n",
  TRY_AGAIN_STRING: "Por favor, tente novamente.\nOBS: As informações das demais blacklists foram atualizadas normalmente.",
  ERROR_LIST_DELTA_ERRORS: "- Delta erros;\n",
  ERROR_LIST_LOG: "- Log;\n",
  ERROR_LIST_FAULTS: "- Falhas;\n",
  ERROR_LIST_ALARMS: "- Alarmes;\n",
  ERROR_LIST_AVAILABILITY: "- Disponibilidade;\n",
  ERROR_LIST_MONITORING: "- Monitoramento;\n",
  ERROR_LIST_SNMP: "- SNMP;\n",

  DEVICES_FROM_BLACKLIST_POPUP_1: "Dispositivos da blacklist de monitormento aparecerão em outras telas com a cor preta",
  DEVICES_FROM_BLACKLIST_POPUP_2: "Dispositivos das demais blacklists aparecerão em outras telas com as cores de seus status",
  DEVICES_FROM_BLACKLIST_POPUP_3: "Dispositivos da blacklist de monitormento aparecem com a cor preta",
  DEVICES_FROM_BLACKLIST_POPUP_4: "Dispositivos das demais blacklists aparecem com as cores normais de seus status",

  // ---------------------------- Edit GSDML page related ----------------------------
  REMOVE_GSDML_SUCCESS: "Os arquivos GSDML foram removidos com sucesso",
  REMOVE_GSDML_FAILURE: "Ocorreu um erro ao remover os arquivos GSDML",
  REMOVE_GSDML_FILES: "Gerenciar arquivos GSDML",
  FILTER_GSDML: "Filtrar arquivos GSDML",
  REMOVING_GSDML_FILES: "Removendo arquivos GSDML",

  // ---------------------------- Device Search related ----------------------------
  MANUAL_SEARCH: "Busca Manual",
  SEARCH_DEVICES: "Buscar dispositivos",
  MANUAL_SEARCH_TURNED_ON_SUCCESS: "A busca manual foi ligada com sucesso.",
  MANUAL_SEARCH_TURNED_OFF_SUCCESS: "A busca manual foi desligada com sucesso.",
  ERROR_ALTERING_SEARCH_STATE: "Ocorreu um erro ao alterar o estado da busca.",
  CHOOSE_SEARCH_QUANTITY: "Por favor escolha a quantidade de buscas a serem realizadas.",
  DEVICE_SEARCH_INIT_SUCCESS: "A busca por dispositivos foi iniciada com sucesso.",
  DEVICE_SEARCH_INIT_FAILURE: "Ocorreu um erro ao iniciar a busca por dispostivos.",
  SEARCH: "Buscar",
  SEARCH_NOUN: "Busca",
  SEARCH_MODE: "Tipo de busca",
  MANUAL_SEARCH_TURNED_OFF: "Desligada",
  MANUAL_SEARCH_TURNED_ON: "Ligada",
  QUANTITY_OF_NEW_SEARCHES: "Quantidade de novas buscas",
  ERROR_FETCHING_SEARCH_STATE: "Ocorreu um erro ao acessar o estado da busca.",

  // ---------------------------- PORTS ----------------------------
  PORTS: "Portas",

  DUPLEX_MODE_1: "Modo",
  DUPLEX_MODE_2: "Duplex",

  INTERFACE_SPEED_1: "Velocidade",
  INTERFACE_SPEED_2: "da interface",

  LINE_DELAY_VALUE_1: "Delay",
  LINE_DELAY_VALUE_2: "Value",

  ACTIVE: "Ativo",
  INACTIVE: "Inativo",

  // ---------------------------- Ping ----------------------------
  MEDIUM_PING: "Ping médio",
  LOST_PACKET_PERC_1: "Pings",
  LOST_PACKET_PERC_2: "Perdidos (%)",
  TENDENCY: "Tendência",
  EXPORT_CSV: "Exportar XLSX",
  MISSED_PINGS_POPUP: "Quantidade / % de pings perdidos nos últimos 360 pings realizados.",

  // ---------------------------- Ping Graph ----------------------------
  DEVICES_TOOLTIP_1: "É possível vizualizar no máximo 5 dispositivos ao mesmo tempo.",
  DEVICES_TOOLTIP_2: "Dispositivos com IP duplicado não são mostrados enquanto o problema não for solucionado.",
  TIME_DP: "Tempo: ",
  TIME: "Tempo",
  PING: "Ping",
  PING_GRAPH: "Gráfico de ping",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configurações WLAN",
  CONNECTION_STATUS: "Estado da conexão",

  WLAN_ADAPTER_ON: "Ligado",
  WLAN_ADAPTER_OFF: "Desligado",

  IP_PLACEHODLER: "192.168.2.215",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Força do sinal",
  FREQUENCY: "Frequência",
  CHANNEL: "Canal",
  QUALITY: "Qualidade",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Qualidade",

  TURNING_WLAN_OFF_WAITING: "Desligando o adaptador WLAN, por favor aguarde.",
  TURNING_WLAN_ON_WAITING: "Ligando o adaptador WLAN, por favor aguarde.",

  NETWORK: "Rede",
  NETWORK_NAME_1: "Nome da rede",
  SUBMASK: "Máscara",
  GATEWAY: "Gateway",
  DNS: "DNS",
  TAG: "Tag",
  PASSWORD: "Senha",
  SETUP: "Configurar",
  YEAR: " ano",
  MONTH: " mês",
  MONTHS: " meses",
  DAY: " dia",
  HOUR: " hora",
  MINUTE: " minuto",
  SECOND: " segundo",

  ALTER_MONITOR_WLAN_CONFIG: "Tem certeza que deseja alterar as configurações de WLAN do monitor?",
  ALTER_OFFICE_INTERFACE_CONFIG_HEADER: "Configurar interface office",
  ALTER_OFFICE_INTERFACE_CONFIG: "Tem certeza que deseja alterar as configurações da interface office?",
  ALTER_OFFICE_INTERFACE_CONFIG_2: "Ao utilizar o modo DHCP tenha certeza de que a interface office não será configurada na mesma subrede que a interface PROFINET, caso contrário o TS Monitor PROFINET poderá apresentar comportamento fora do esperado.",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica o estado do adaptador WLAN do monitor.",
  WLAN_STATUS_POPUP_2: "Caso ele esteja desligado não é possível alterar as configurações WLAN.",

  CONNECTION_STATUS_POPUP_1: "Indica se o monitor está conectado ou não à rede WLAN configurada.",
  CONNECTION_STATUS_POPUP_1_1: "Indica se o monitor está conectado ou não à rede Ethernet configurada.",

  WLAN_CONFIG_POPUP_1: "Não é possível alterar as configurações enquanto o adaptador WLAN estiver desligado.",
  WLAN_CONFIG_POPUP_2: "É altamente recomendado que as configurações de WLAN sejam alteradas apenas ao acessar o monitor por meio da rede cabeada.",
  WLAN_CONFIG_POPUP_3: "Ao alterar o IP / máscara, caso os campos apareçam em branco após a atualização isso é um forte indicativo de que:",
  WLAN_CONFIG_POPUP_4: "Já existe um outro dispositivo na rede com o mesmo IP;",
  WLAN_CONFIG_POPUP_5: "A máscara de rede é muito restrita e não comporta o IP que foi passado.",

  WLAN_ADAPTER_NOT_FOUND_1: "O TS Monitor PROFINET não conseguiu encontrar o adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Verifique se o adaptador está desconectado, ou com mal contato;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Caso o adaptador não esteja desconectado nem com mal contato, tente substituí-lo;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Se nenhuma das opções anteriores solucionar o problema entre em contato com a Toledo e Souza.",

  HOSTNAME_POPUP_1: "Um hostname deve possuir entre 2 e 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Além disso, ele pode conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",

  INVALID_HOSTNAME_1: "O hostname deve possuir entre 2 e 64 caracteres.",
  INVALID_HOSTNAME_2: "O hostname deve conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",

  HOSTNAME_CONFIG_SUCCESS: "O hostname foi configurado com sucesso.",
  HOSTNAME_CONFIG_ERROR: "Ocorreu um erro ao configurar o hostname",
  MODE: "Modo",
  HIDDEN_SSID: "SSID Oculto",
  OPTIONAL: " (Opcional)",
  FIXED_IP: "IP Fixo",

  // ---------------------------- INVENTORY ----------------------------
  INVENTORY_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, MAC, nome ou modelo",
  MANUFACTURER: "Fabricante",
  ORDER_NUMBER: "Order number",
  VERSION_OF: "Versão de ",
  IO_CONTROLLER_POPUP_1: "Esta coluna mostra a quais IO Controllers o dispositivo está associado.",
  IO_CONTROLLER_POPUP_2: "É possível que o dispositivo esteja:",
  IO_CONTROLLER_POPUP_3: "Associado a um IO Controller;",
  IO_CONTROLLER_POPUP_4: "Associado a mais de um IO Controller;",
  IO_CONTROLLER_POPUP_5: "Não associado a nenhum IO Controller.",

  DEVICE_COUNTERS_POPUP: "Os números ao lado indicam os totais de cada tipo de equipamento.",

  NO_IO_CONTROLLER: "Não associado",
  ASSOCIATED: "associado",
  ORDER_NUMBER_N: "Order\nnumber",
  HARDWARE_VERSION_N: "Versão de\nHardware",
  FIRMWARE_VERSION_N: "Versão de\nFirmware",
  IO_CONTROLLER: "IO Controller",

  INVENTORY_CSV_HEADER: "Nome,MAC,IP,Função,Modelo,Fabricante,Order number,Versão de hardware,Versão de firmware,IO Controller associado\n",
  INVENTORY_EXPORT_NAME: "Inventário.xlsx",

  // ---------------------------- TS EXPERT CONFIG ----------------------------
  CURRENT_VALUE_DP: "Valor atual: ",
  SAVE: "Salvar",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Atualizando as configurações do TS Expert, aguarde um instante.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "As configurações do TS Expert foram salvas com sucesso.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocorreu um erro ao salvar as configurações do TS Expert.",

  TS_EXPERT_CONFIGURATION: "Configurações do TS Expert",

  CONFIG_DIAGNOSTIC_LIST_HEADER: "Alarmes",
  CONFIG_DIAGNOSTIC_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar toda vez que um dispositivo PROFINET possuir alarmes. Alarme é uma informação de condição anormal ou mal funcionamento enviada pelo IO Device ao IO Controller, solicitando manutenção ou até mesmo substituição.",

  CONFIG_FAULT_LIST_HEADER: "Falhas",
  CONFIG_FAULT_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar toda vez que um dispositivo PROFINET possuir falhas. Isso indica que ele não está respondendo a comandos ping e arp na rede, ou seja, não está acessível via rede.",

  CONFIG_DUPLICATE_NAME_LIST_HEADER: "Profiname duplicado",
  CONFIG_DUPLICATE_NAME_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar toda vez que dois dispositivos estiverem configurados com o mesmo profiname. Isso pode gerar falha de comunicação.",

  CONFIG_DUPLICATE_IP_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar toda vez que um IP duplicado for detectado na rede.",

  CONFIG_EXCEEDED_PING_LIST_HEADER: "Tempo de ping excedido",
  CONFIG_EXCEEDED_PING_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar toda vez que o ping médio de um dispositivo exceder o valor de ping limite.",

  CONFIG_ERROR_INCREMENT_LIST_HEADER: "Incrementos de erro",
  CONFIG_ERROR_INCREMENT_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar todas as vezes que um dispositivo possuir incremento de pacotes com erro de entrada e/ou saída em alguma de suas portas.",

  CONFIG_DUPLEX_LIST_HEADER: "Porta configurada em um modo Duplex e/ou velocidade não recomendados",
  CONFIG_DUPLEX_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar toda vez que a configuração de uma porta for diferente de: Full Duplex a 100 Mbps ou Full Duplex a 1000 Mbps (Portas configuradas em Half Duplex costumam gerar colisões e perdas de pacote, o que é um problema para um protocolo de controle e troca de dados em tempo real. Links configurados em 10 Mbps podem se tornar gargalos de comunicação e impedir a transmissão de pacotes).",

  CONFIG_TRAFFIC_EXCEEDED_LIST_HEADER: " Excesso de tráfego de entrada / saída",
  CONFIG_TRAFFIC_EXCEEDED_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar toda vez que for detectado tráfego total superior a 50 Mbps em determinada porta.",

  CONFIG_INACTIVE_PORT_LIST_HEADER: "Porta inativada",
  CONFIG_INACTIVE_PORT_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar toda vez que uma porta ativa for desativada, seja pela desconexão ou rompimento de um cabo ou pelo desligamento ou desconexão do dispositivo na extremidade oposta do cabo. Pode indicar um problema no cabo, conector, no dispositivo da extremidade oposta ou até na própria eletrônica do dispositivo que teve a porta desativada.",

  HW_FW_PORT_LIST_HEADER: "Versão de hardware igual e firmware diferente",
  HW_FW_PORT_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar toda vez que forem detectados dispositivos com versões de hardware iguais, porém versões de firmware diferentes. Esses dispositivos podem apresentar funcionalidades, características e comportamentos diferentes. Este indicativo visa cruzar informações de falhas que possam estar ocorrendo isoladamente em um ou outro dispositivo e que possam ter relação com versões de firmware.",

  CONFIG_ERROR_CONFIG_LIST_HEADER: "Módulo diferente do configurado",
  CONFIG_ERROR_CONFIG_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar toda vez que for detectado um módulo diferente do configurado. Esta falha de configuração acontece quando o módulo declarado no software de configuração é diferente do instalado fisicamente no IO Device.",

  DUPLEX_MISMATCH_CONFIG_LIST_HEADER: "Incompatibilidade de modo Duplex",
  DUPLEX_MISMATCH_CONFIG_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar todos os links que retornaram com informação de Duplex e apresentam incompatibilidade entre si, por exemplo, uma porta Half Duplex conectada a outra em Full Duplex.",

  DELAY_EXCEEDED_CONFIG_LIST_HEADER: "Delay",
  DELAY_EXCEEDED_CONFIG_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todos os links que retornaram com valores de atraso no link ou no cabo superiores aos recomendados pelas diretrizes do PROFINET.",

  CONFIG_INTERMITTENT_FAILURE_LIST_HEADER: "Falhas intermitentes",
  CONFIG_INTERMITTENT_FAILURE_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar falhas intermitentes dos devices PROFINET. Isso indica que o device está perdendo comunicação e recuperando rapidamente.",

  CONFIG_LOST_IP_LIST_HEADER: "Perda de endereço IP",
  CONFIG_LOST_IP_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar toda vez que for detectado um dispositivo com uma possível perda de endereço IP (0.0.0.0).",

  PING_LIMIT: "Ping limite",
  ALTER_PING_LIMIT_SUCCESS: "O ping limite foi alterado com sucesso.",
  ALTER_PING_LIMIT_ERROR: "Ocorreu um erro ao alterar o ping limite.",

  PING_LIMIT_POPUP_1: "O ping limite é o valor de ping médio acima do qual é considerado que existe um problema com o dispositivo. Se o isso ocorrer, um evento será criado no TS Expert.",
  PING_LIMIT_POPUP_2: "A cada vez que um dispositivo ultrapassar esse valor um evento será criado no TS Expert.",
  PING_LIMIT_POPUP_3: "A unidade de medida do ping é milissegundos (ms).",
  PING_LIMIT_POPUP_4: "O valor mínimo permitido para o ping limite é de 0 ms.",
  PING_LIMIT_POPUP_5: "O valor máximo permitido para o ping limite é de 10.000 ms (10 segundos).",

  PING_LIMIT_OUT_OF_BOUNDS: "O ping limite precisa estar entre 0 e 10.000 ms (10 segundos).",

  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de ações - TS Expert - PROFINET",

  TS_EXPERT_POPUP_1: "Nesta aba são apresentadas as informações do TS Expert.",
  TS_EXPERT_POPUP_2: "Esta ferramenta é um sistema especialista desenvolvido para otimizar e acelerar a análise das principais divergências detectadas pelo TS Monitor em redes PROFINET.",
  TS_EXPERT_POPUP_3: "De forma automatizada, a manutenção, engenharia e equipes relacionadas podem obter uma lista de ações com diferentes eventos, suas possíveis causas, sugestões de solução e os dispositivos nos quais foram detectados.",
  TS_EXPERT_POPUP_4: "O uso do TS Expert não exclui a necessidade da análise humana e tampouco substitui tais capacidades de criar correlações de dados e interpretação.",

  TS_EXPERT: "TS Expert",
  DETECTED_ON: "Detectado em: ",
  CHECK_YOUR_NETWORK: "Por favor verifique sua rede.",

  EXPORT_ACTIONS_LIST: "Exportar lista de ações",
  GENERATING_ACTIONS_LIST_WAITING: "Gerando PDF de lista de ações, por favor aguarde.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF gerado com sucesso. Para salvá-lo, clique em salvar lista de ações.",

  EVENTS_LIST: "Lista de eventos",
  ACTIONS: "Ações",

  NO_PROBLEM_DETECTED: "O TS Expert não detectou nenhum evento na rede.",
  NO_EVENTS_TO_BE_ANALYZED: "Não existem eventos a serem analisados.",

  NO_EVENT_SELECTED: "Nenhum evento selecionado",
  CHOOSE_AN_EVENT: "Escolha um evento para visualizar as ações sugeridas.",

  DETAILING: "Detalhamento",

  CHECKED: "Conferido",
  BATCH_CHECK: "Conferir todos",

  PROBLEM_CHECKED: "O evento foi conferido com sucesso",
  PROBLEM_CHECK_ERROR: "Ocorreu um erro ao conferir o evento.",

  QUANTITY_DP: "Quantidade: ",
  INCREMENTS: "Incrementos",

  PORT_IS_STILL_INACTIVE: "A porta ainda está inativa",
  MARK_PROBLEM_AS_SOLVED: "Tem certeza que deseja marcar o evento como conferido?",

  LAST_UPDATED: "Atualizado pela última vez em: ",
  THIS_COMPUTER_TIME: " (Horário deste computador)",

  RECEIVED_INFO: "Informações recebidas",
  EXPECTED_INFO: "Informações esperadas",

  RECEIVED_INFO_DP: "Informações recebidas:",
  EXPECTED_INFO_DP: "Informações esperadas:",

  MODULE_NUMBER_DP: "Nome do módulo:",
  ALL_EVENTS_WERE_CHECKED: "Todos os eventos foram conferidos com sucesso.",
  CHECK_EVENT_OBS: "\nImportante salientar que alguns dados levam até 15 minutos para serem atualizados, desta forma, sugere-se aguardar algum tempo para limpar esta lista clicando em conferir.\n",
  ACTIONS_LIST_NAME: "Lista de ações - TS Expert - PROFINET.pdf",
  SAVE_ACTIONS_LIST: "Salvar lista de ações",
  ACTIONS_LIST: "Lista de ações",

  UNABLE_TO_CHECK_ALARMS_EVENT: "Não foi possível conferir o evento do dispositivo, pois ele ainda possui alarmes ativos\n",
  UNABLE_TO_CHECK_FAULT_EVENT: "Não foi possível conferir o evento do dispositivo, pois ele ainda se encontra em estado de falha\n",
  UNABLE_TO_CHECK_DUPLICATE_IP_EVENT: "Não foi possível conferir o evento do dispositivo, pois ele ainda está com IP duplicado\n",
  UNABLE_TO_CHECK_DUPLICATE_NAME_EVENT: "Não foi possível conferir o evento do dispositivo, pois ele ainda está com profiname duplicado\n",
  UNABLE_TO_CHECK_PING_LIMIT_EVENT: "Não foi possível conferir o evento do dispositivo, pois o valor de ping médio continua acima do valor configurado de limite de ping\n",
  UNABLE_TO_CHECK_DELTA_ERROR_EVENT: "Não foi possível conferir o evento do dispositivo, pois ele possui portas com incrementos de erro\n",
  UNABLE_TO_CHECK_NOT_IN_FULL_DUPLEX_EVENT: "Não foi possível conferir o evento do dispositivo, pois sua porta ainda continua configurada em um modo duplex e/ou velocidade não recomendados\n",
  UNABLE_TO_CHECK_TRAFFIC_EXCESS_EVENT: "Não foi possível conferir o evento do dispositivo, pois o tráfego nas seguintes portas ainda excede 50 Mbps\n",
  UNABLE_TO_CHECK_INACTIVE_PORT_EVENT: "Não foi possível conferir o evento do dispositivo, pois sua porta continua inativada (estava ativa e passou a ficar inativa)\n",
  UNABLE_TO_CHECK_HW_FW_EVENT: "Não foi possível conferir o evento, pois os dispositivo ainda possuem versões de hardware iguais, porém versões de firmware diferentes\n",
  UNABLE_TO_CHECK_MODULE_INCOHERENCE_EVENT: "Não foi possível conferir o evento do dispositivo, pois ele ainda possui módulos diferentes dos declarados no software de configuração\n",
  UNABLE_TO_CHECK_DUPLEX_MISMATCH_EVENT: "Não foi possível conferir o evento do dispositivo, pois ele ainda possui incompatibilidade de modo Duplex\n",
  UNABLE_TO_CHECK_DELAY_EXCEEDED_EVENT: "Não foi possível conferir o evento do dispositivo, pois sua porta ainda excede o valor limite de delay\n",
  UNABLE_TO_CHECK_INTERMITTENT_FAILURE_EVENT: "Não foi possível conferir o evento do dispositivo, pois ele possui falhas intermitentes\n",
  UNABLE_TO_CHECK_LOST_IP_EVENT: "Não foi possível conferir o evento do dispositivo, pois ele  ainda apresenta possivel perda de IP\n",

  UNABLE_TO_CHECK_ALARMS_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem alarmes ativos:\n",
  UNABLE_TO_CHECK_FAULT_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda se encontram em estado de falha:\n",
  UNABLE_TO_CHECK_DUPLICATE_IP_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda estão com IP duplicado:\n",
  UNABLE_TO_CHECK_DUPLICATE_NAME_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda estão com profiname duplicado:\n",
  UNABLE_TO_CHECK_PING_LIMIT_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois os valores de ping médio continuam acima do valor configurado de limite de ping:\n",
  UNABLE_TO_CHECK_DELTA_ERROR_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles possuem portas com incrementos de erro:\n",
  UNABLE_TO_CHECK_NOT_IN_FULL_DUPLEX_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois suas portas ainda continuam configuradas em um modo duplex e/ou velocidade não recomendados:\n",
  UNABLE_TO_CHECK_TRAFFIC_EXCESS_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois o tráfego nas seguintes portas ainda excede 50 Mbps:\n",
  UNABLE_TO_CHECK_INACTIVE_PORT_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois suas portas continuam inativadas (estava ativa e passou a ficar inativa):\n",
  UNABLE_TO_CHECK_HW_FW_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem versões de hardware iguais, porém com versões de firmware diferentes:\n",
  UNABLE_TO_CHECK_MODULE_INCOHERENCE_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem módulos diferentes dos declarados no software de configuração:\n",
  UNABLE_TO_CHECK_DUPLEX_MISMATCH_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem incompatibilidade de modo Duplex:\n",
  UNABLE_TO_CHECK_DELAY_EXCEEDED_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois suas portas ainda excedem o valor limite de delay:\n",
  UNABLE_TO_CHECK_INTERMITTENT_FAILURE_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem falhas intermitentes:\n",
  UNABLE_TO_CHECK_LOST_IP_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda apresentam possivel perda de IP:\n",

  HARDWARE_VERSION: "Versão de hardware",

  // ---------------------------- DIAGNOSTICS ----------------------------
  DIAGNOSTIC_LIST_HEADER: "Existem dispositivos na rede que possuem alarmes.",
  DEVICE_WITH_DIAGNOSTIC: "Dispositivo com alarme",

  DIAGNOSTIC_SUGGESTION_1: "Quando um dispositivo possuir alarmes sugere-se:",
  DIAGNOSTIC_SUGGESTION_2: "Verificar a informação enviada pelo próprio IO Device (detectada e transformada em texto pelo TS Monitor) e tentar solucionar o problema. Caso tenha dificuldade em entender o diagnóstico entre em contato com o fabricante do dispositivo ou verifique o manual do IO Device para sanar suas dúvidas antes de uma intervenção.",

  NO_DEVICE_WITH_DIAGNOSTIC: "Não existem dispositivos na rede com alarmes ativos",

  // ---------------------------- FAULTS ----------------------------
  FAULTS_LIST_HEADER: "Existem dispositivos na rede que possuem falhas.",
  DEVICE_WITH_FAULT: "Dispositivo com falha",

  FAULT_SUGGESTION_1: "Quando um dispositivo possuir falhas sugere-se:",
  FAULT_SUGGESTION_2: "Verificar a alimentação do IO Device;",
  FAULT_SUGGESTION_3: "Verificar se ele está conectado fisicamente à rede;",
  FAULT_SUGGESTION_4: "Verificar a integridade do conector;",
  FAULT_SUGGESTION_5: "Verificar a integridade do cabo;",
  FAULT_SUGGESTION_6: "Verificar se o dispositivo perdeu seu endereço IP. Quando isso ocorrer ele aparecerá no monitor com o IP: 0.0.0.0, além disso seu IP estará marcado com a cor laranja na Live List.",

  NO_DEVICE_WITH_FAULT: "Não existem dispositivos na rede com falhas",

  // ---------------------------- DUPLICATE IP ----------------------------
  DUPLICATE_IP_LIST_HEADER: "Existem dispositivos na rede com IP duplicado.",
  DEVICES_WITH_DUPLICATE_IP: "Dispositivos com IP duplicado",

  DUPLICATE_IP_CARD_DESC: "Os dispositivos abaixo estão utilizando o endereço de IP: ",

  DUPLICATE_IP_SUGGESTION_1: "Quando existirem IPs duplicados na rede sugere-se:",
  DUPLICATE_IP_SUGGESTION_2: "Conferir os endereços físicos, MAC, para identificar os dispositivos que apresentam conflito de endereço IP e corrigir as configurações deste endereço.",

  NO_DEVICES_WITH_DUPLICATE_IPS: "Não existem dispositivos na rede com IPs duplicados",

  // ---------------------------- DUPLICATE NAME ----------------------------
  DUPLICATE_NAME_LIST_HEADER: "Existem dispositivos na rede com profiname duplicado.",
  DEVICES_WITH_DUPLICATE_NAME: "Dispositivos com profiname duplicado",

  DUPLICATE_NAME_CARD_DESC: "Os dispositivos abaixo estão utilizando o nome: ",

  DUPLICATE_NAME_SUGGESTION_1: "Quando existirem dispositivos na rede com profiname duplicado sugere-se:",
  DUPLICATE_NAME_SUGGESTION_2: "Verificar o projeto e alterar o IO Device que estiver com profiname errado.",

  NO_DEVICES_WITH_DUPLICATE_NAMES: "Não existem dispositivos na rede com profiname duplicados",

  // ---------------------------- PING LIMIT ----------------------------
  GROUP_PING_LIMIT_HEADER: "Existem dispositivos na rede que excederam o valor limite de ping.",
  PING_LIMIT_EXCEEDED: "Limite de ping excedido",

  REGISTERED_PING: "Ping registrado: ",

  PING_LIMIT_SUGGESTION_1: "Quando um dispositivo exceder o valor limite de ping sugere-se:",
  PING_LIMIT_SUGGESTION_2: "Problemas de tráfego:",
  PING_LIMIT_SUGGESTION_3: "Utilizar a aba de Tráfego e revisar as aplicações que estão utilizando o link, veja se estão de acordo com a infraestrutura disponível;",
  PING_LIMIT_SUGGESTION_4: "Verificar se a largura de banda disponível atende a aplicação (uso de switches Fast ou Gigabit Ethernet).",

  PING_LIMIT_SUGGESTION_5: "Alto uso de processamento de equipamentos e switches:",
  PING_LIMIT_SUGGESTION_6: "Revisar o consumo de dados da aplicação;",
  PING_LIMIT_SUGGESTION_7: "Revisar a temperatura dos equipamentos.",

  PING_LIMIT_SUGGESTION_8: "Atraso na propagação (Comprimento excessivo de cabos):",
  PING_LIMIT_SUGGESTION_9: "Identificar o comprimento do cabo, visualmente quando gravado no cabo, ou utilizando testadores ou certificadores.",

  NO_DEVICE_EXCEEDED_PING_LIMIT: "Não existem dispositivos na rede que excederam o valor limite de ping",

  // ---------------------------- DELTA ERROR ----------------------------
  DELTA_ERROR_LIST_HEADER: "Existem dispositivos na rede com portas que possuem incrementos de erro.",
  DELTA_ERROR_ALARM: "Incrementos de erro",
  DEVICE_HAS_DELTA_ERROR_PROBLEMS: "O dispositivo possui incrementos de erro nas seguintes portas:",

  DELTA_ERRORS_SUGGESTION_1: "Quando um dispositivo tiver portas que possuem incrementos de erro sugere-se:",
  DELTA_ERRORS_SUGGESTION_2: "Erros na entrada",
  DELTA_ERRORS_SUGGESTION_3: "Verificar se há incompatibilidade de Duplex (uma porta 100 Mbps Full Duplex conectada a uma porta 10 Mbps Half Duplex). Os links devem ter a mesma configuração em ambas as extremidades e, preferencialmente, utilizar autonegociação;",
  DELTA_ERRORS_SUGGESTION_4: "Conferir se as rotas dos cabos de dados em eletrocalhas, eletrodutos e bandejas estão próximas de cabeamento de potência, drives e demais dispositivos de maior consumo cujo cabeamento possa gerar interferência. Os cabos de rede devem estar o mais distante possível ou em eletrodutos isolados e aterrados;",
  DELTA_ERRORS_SUGGESTION_5: "Verificar a qualidade dos links Ethernet. Conectores mal montados, cabos e conectores de baixa qualidade podem gerar perdas;",
  DELTA_ERRORS_SUGGESTION_6: "Utilizando certificador, verificar se os cabos estão íntegros e com capacidade de desempenho para a categoria (Cat5, Cat5e, Cat6, etc.).",
  DELTA_ERRORS_SUGGESTION_7: "Erros na saída",
  DELTA_ERRORS_SUGGESTION_8: "Verificar se há incompatibilidade de Duplex (uma porta 100 Mbps Full Duplex conectada a uma porta 10 Mbps Half Duplex). Links devem ter a mesma configuração em ambas as extremidades e, preferencialmente, utilizar autonegociação;",
  DELTA_ERRORS_SUGGESTION_9: "Verificar a qualidade dos links Ethernet. Conectores mal montados, cabos e conectores de baixa qualidade podem gerar perdas;",
  DELTA_ERRORS_SUGGESTION_10: "Verificar possíveis problemas na interface de rede do dispositivo, sendo necessária sua substituição caso forem detectados.",

  DEVS_WITH_DELTA_ERRORS_EXPLANATION_1: "Nesta lista são mostrados apenas os dispositivos e respectivas portas que possuam incrementos de erro de entrada ou saída.",
  DEVS_WITH_DELTA_ERRORS_EXPLANATION_2: "Os contadores de erro que possuirem incremento estarão destacados com a cor laranja.",

  NO_DEVICE_WITH_DELTA_ERRORS_LIMIT: "Não existem dispositivos na rede com portas que possuem incrementos de erro",

  // ---------------------------- NOT IN FULL DUPLEX ----------------------------
  NOT_IN_FULL_DUPLEX_LIST_HEADER: "Existem dispositivos na rede com portas configuradas em um modo Duplex e/ou velocidade não recomendados.",
  PORT_NOT_IN_FULL_DUPLEX: "Porta configurada em um modo Duplex e/ou velocidade não recomendados",

  DUPLEX_MODE: "Modo Duplex",

  NOT_IN_FULL_DUPLEX_SUGGESTION_1: "Quando uma porta estiver configurada em um modo Duplex e/ou velocidade não recomendados sugere-se:",
  NOT_IN_FULL_DUPLEX_SUGGESTION_2: "Verificar se as portas estão com a função autonegociação habilitada. Caso esteja fixada sugere-se alterar para taxa de transmissão de ao menos 100Mb e modo Duplex como Full Duplex.",
  NOT_IN_FULL_DUPLEX_SUGGESTION_3: "Caso a opção autonegociação esteja habilitada e o link continue em Half Duplex, sugere-se troca do cabeamento e, caso esta opção não leve a negociação de Full Duplex, pode-se realizar a troca das interfaces de rede.",

  NO_DEVICES_WITHOUT_FULL_DUPLEX: "Não existem dispositivos na rede com portas configuradas em um modo Duplex e/ou velocidade não recomendados",

  // ---------------------------- TRAFFIC EXCESS ----------------------------
  TRAFFIC_EXCESS_LIST_HEADER: "Existem dispositivos na rede com portas que excederam 50 Mbps de tráfego.",
  TRAFFIC_EXCESS: "Tráfego excedeu 50 Mbps",
  DEVICE_HAS_TRAFFIC_EXCESS_ERROR_PROBLEMS: "O dispositivo excedeu 50 Mbps de tráfego nas seguintes portas:",

  TRAFFIC_EXCESS_SUGGESTION_1: "Quando um dispositivo tiver portas que excederam 50 Mbps de tráfego de entrada ou saída:",
  TRAFFIC_EXCESS_SUGGESTION_2: "As diretrizes PROFINET indicam tráfego aceitável até 20% (ou 20Mbps em links 100Mb), tráfego a ser revisto entre 20 e 50% e necessidade de ação imediata em caso de tráfego superiores a 50%. Quando o tráfego for superior a 50Mbps, sugere-se:",
  TRAFFIC_EXCESS_SUGGESTION_3: "Estudar a viabilidade de aumentar o tempo de ciclo de resposta dos IO Devices (considerar tempos de processo, segurança, etc);",
  TRAFFIC_EXCESS_SUGGESTION_4: "Dividir dispositivos em subredes e controladores diferentes;",
  TRAFFIC_EXCESS_SUGGESTION_5: "Analisar a topologia e verificar a possibilidade de criar novos caminhos para um determinado tráfego mais alto, por exemplo, adicionando switches;",
  TRAFFIC_EXCESS_SUGGESTION_6: "Verificar origem deste tráfego e se há necessidade deste dispositivo estar comunicando na rede PROFINET (isolar os dispositivos que realizam controle de outros que são usados para manutenção, coleta de dados ou quaisquer outras tarefas que não operem em tempo real).",

  DEVS_WITH_TRAFFIC_EXCESS_EXPLANATION_1: "Nesta lista são mostrados apenas os dispositivos e respectivas portas cujo tráfego de entrada ou saída excedeu 50 Mbps.",
  DEVS_WITH_TRAFFIC_EXCESS_EXPLANATION_2: "O tráfego que exceder 50 Mbps estará destacado com a cor laranja.",

  NO_DEVICE_WITH_TRAFFIC_EXCESS: "Não existem dispositivos na rede com portas que excederam 50 Mbps de tráfego.",

  INPUT_TRAFFIC_KBPS: "Tráfego na\nentrada (Kbps)",
  OUTPUT_TRAFFIC_KBPS: "Tráfego na\nsaída (Kbps)",

  // ---------------------------- INACTIVE PORT ----------------------------
  INACTIVE_PORT_LIST_HEADER: "Existem dispositivos na rede cujas portas foram inativadas.",
  INACTIVE_PORT: "Porta inativada",

  INACTIVE_PORT_SUGGESTION_1: "Quando uma porta estiver inativada (estava ativa e passou a ficar inativa)\nsugere-se:",
  INACTIVE_PORT_SUGGESTION_2: "Verificar cabo e conector (em ambas as extremidades), alimentação do dispositivo conectado a extremidade oposta e rompimento do cabo. Em último caso sugere-se a substituição do módulo.",

  NO_DEVICES_WITH_INACTIVE_PORTS: "Não existem dispositivos na rede que possuam portas inativadas (estava ativa e passou a ficar inativa)",

  // ---------------------------- HARDWARE / FIRMWARE ----------------------------
  HW_FW_LIST_HEADER: "Existem dispositivos na rede com versões de hardware iguais, mas versões de firmware diferentes.",
  HW_FW: "Versões de hardware iguais e firmware diferentes",
  SAME_HW_DIFF_FW: "Os dispositivos abaixo possuem versões de hardware iguais, porém versões de firmware diferentes",
  FIRMWARE: "Firmware",

  HW_FW_SUGGESTION_1: "Quando dois dispositivos possuirem a mesma versão de hardware, mas versões diferentes de firmware sugere-se:",
  HW_FW_SUGGESTION_2: "Atualizar o firmware destes dispositivos, de modo que todos fiquem iguais, para manter a estabilidade da rede e das funcionalidades dos dispositivos.",
  HW_FW_SUGGESTION_3: "É muito importante realizar esta operação fora de produção e consultar o fabricante do dispositivo antes de iniciar esta tarefa a fim de evitar problemas de incompatibilidade e operação.",

  NO_DIFF_HW_FW: "Não existem dispositivos na rede com versões de hardware iguais, mas versões de firmware diferentes.",

  // ---------------------------- MODULE INCOHERENCE ----------------------------
  MODULE_INCOHERENCE_LIST_HEADER: "Existem dispositivos na rede com módulos diferentes dos declarados no software de configuração.",
  MODULE_INCOHERENCE: "Módulo diferente do declarado no software de configuração",
  INCOHERENCE_IN_MODULE: "Diferença detectada no seguinte módulo",

  MODULE_INCOHERENCE_SUGGESTION_1: "Quando o dispositivo tiver módulos diferentes dos declarados no software de configuração sugere-se:",
  MODULE_INCOHERENCE_SUGGESTION_2: "Verificar a configuração e instalação a fim de sanar a divergência informada pelo dispositivo.",

  NO_DIFF_MODULES: "Não existem dispositivos na rede com módulos diferentes dos declarados no software de configuração.",
  MODULE: "Módulo",

  // ---------------------------- DUPLEX MISMATCH ----------------------------
  DUPLEX_MISMATCH_LIST_HEADER: "Existem dispositivos na rede com incompatibilidade de modo Duplex.",
  DUPLEX_MISMATCH: "Incompatibilidade de modo Duplex",

  DUPLEX_MISMATCH_SUGGESTION_1: "Quando dois dispositivos tiverem incompatibilidade de modo Duplex sugere-se:",
  DUPLEX_MISMATCH_SUGGESTION_2: "Verificar a configuração das portas em ambas as extremidades a fim de verificar se estão em Autonegociação ou se estão com o modo Duplex forçado em alguma condição;",
  DUPLEX_MISMATCH_SUGGESTION_3: "Caso ambas as portas estejam em autonegociação, sugere-se testar integridade do cabeamento;",
  DUPLEX_MISMATCH_SUGGESTION_4: "Em último caso, realizar substituição da interface de rede do dispositivo.",

  NO_DEVICES_WITH_DUPLEX_MISMATCH: "Não existem dispositivos na rede com incompatibilidade de modo Duplex.",

  // ---------------------------- DELAY EXCEEDED ----------------------------
  DELAY_EXCEEDED_LIST_HEADER: "Existem dispositivos na rede com alteração de delay.",
  DELAY_EXCEEDED: "Alteração de delay",

  DELAY_EXCEEDED_SUGGESTION_1: "Quando um dispositivo possuir alteração de delay sugere-se:",
  DELAY_EXCEEDED_SUGGESTION_2: "Para o caso de Cable Delay alterado, sugere-se verificação do meio físico, certificando os links, conferindo comprimento dos cabos (pode-se identificar pela numeração da metragem gravada no cabo), montagem adequada de conectores e qualidade e categoria (mínimo Cat5) dos itens utilizados nesta infraestrutura;",
  DELAY_EXCEEDED_SUGGESTION_3: "Para o caso de Line Delay alterado, vale a mesma sugestão anterior e, caso não traga resultados, sugere-se substituição das interfaces de rede, uma vez que este parâmetro indica os tempos não apenas no cabo, mas também no receptor e transmissor somados;",

  // ---------------------------- INTERMITTENT FAULTS ----------------------------
  INTERMITTENT_FAILURES_LIST_HEADER: "Existem dispositivos na rede que possuem falhas intermitentes.",
  DEVICE_WITH_INTERMITTENT_FAILURE: "Dispositivo com falha intermitente",

  INTERMITTENT_FAILURES_SUGGESTION_1: "Quando um dispositivo possuir falhas intermitentes sugere-se:",
  INTERMITTENT_FAILURES_SUGGESTION_2: "Verificar a alimentação do IO Device;",
  INTERMITTENT_FAILURES_SUGGESTION_3: "Verificar a integridade do conector;",
  INTERMITTENT_FAILURES_SUGGESTION_4: "Verificar a integridade do cabo.",

  NO_DEVICE_WITH_INTERMITTENT_FAILURE: "Não existem dispositivos na rede com falhas intermitentes",

  // ---------------------------- LOST IP ----------------------------
  LOST_IP_LIST_HEADER: "Existem dispositivos com possível perda de IP na rede.",
  LOST_IP_DESCR: "Por favor verifique sua rede.",
  DEVICE_WITH_LOST_IP: "Dispositivo com possível perda de IP",

  LOST_IP_SUGGESTION_1: "Quando um dispositivo apresentar possível perda de IP sugere-se:",
  LOST_IP_SUGGESTION_2: "Conferir os endereços físicos, MAC, para identificar os dispositivos que apresentam conflito de endereço IP e corrigir as configurações deste endereço.",

  // ---------------------------- EXPERT REPORT ----------------------------
  DIAGNOSTIC_PAGE_TITLE: ". - Dispositivo com alarme",
  FAULT_PAGE_TITLE: ". - Dispositivo com falha",
  DUPLICATE_IP_PAGE_TITLE: ". - Dispositivos com IP duplicado",
  DUPLICATE_NAME_PAGE_TITLE: ". - Dispositivos com profiname duplicado",
  PING_LIMIT_EXCEEDED_PAGE_TITLE: ". - Limite de ping excedido",
  DELTA_ERROR_ALARM_PAGE_TITLE: ". - Incrementos de erro",
  PORT_NOT_IN_FULL_DUPLEX_PAGE_TITLE: ". - Porta configurada em um modo Duplex e/ou velocidade não recomendados",
  TRAFFIC_EXCESS_PAGE_TITLE: ". - Tráfego excedeu 50 Mbps",
  INACTIVE_PORT_PAGE_TITLE: ". - Porta inativada",
  HW_FW_TITLE: ". - Versões de hardware iguais e firmware diferentes",
  MODULE_INCOHERENCE_TITLE: ". - Módulo diferente do declarado no software de configuração",
  DUPLEX_MISMATCH_PAGE_TITLE: ". - Incompatibilidade de modo Duplex",
  DELAY_EXCEEDED_PAGE_TITLE: ". - Alteração de delay",
  INTERMITTENT_FAILURE_PAGE_TITLE: ". - Dispositivo com falha intermitente",
  LOST_IP_PAGE_TITLE: ". - Dispositivo com possível perda de IP",

  PORTUGUESE: "Português",
  ENGLISH: "Inglês",
  SPANISH: "Espanhol",
  GERMAN: "Alemão",
  UPDATING_LANGUAGE_WAITING: "Alterando idioma, aguarde um instante",
  UNABLE_TO_ALTER_LANGUAGE: "Não foi possivel alterar o idioma do programa.\n",

  // ---------------------------- EXPERT REPORT ----------------------------
  DEVICE_WITH_DIAGNOSTIC_DOTS: ".............................................................................................................",
  DEVICE_WITH_FAULT_DOTS: "................................................................................................................",
  DEVICES_WITH_DUPLICATE_IP_DOTS: "..................................................................................................",
  DEVICES_WITH_DUPLICATE_NAME_DOTS: "....................................................................................",
  PING_LIMIT_EXCEEDED_DOTS: ".............................................................................................................",
  DELTA_ERROR_ALARM_DOTS: "...................................................................................................................",
  PORT_NOT_IN_FULL_DUPLEX_DOTS: ".....................",
  TRAFFIC_EXCESS_DOTS: ".........................................................................................................",
  INACTIVE_PORT_DOTS: "...........................................................................................................................",
  HW_FW_DOTS: "...............................................................",
  HW_FW_DOTS_2: "..................................................................",
  MODULE_INCOHERENCE_DOTS: "..............................................",
  MODULE_INCOHERENCE_DOTS_2: "................................................",
  DUPLEX_MISMATCH_DOTS: "........................................................................................",
  DUPLEX_MISMATCH_DOTS_2: "...........................................................................................",

  DELAY_EXCEEDED_DOTS: "....................................................................................................................",
  DELAY_EXCEEDED_DOTS_2: ".......................................................................................................................",

  DEVICE_WITH_INTERMITTENT_FAILURE_DOTS: ".........................................................................................",
  DEVICE_WITH_INTERMITTENT_FAILURE_DOTS_2: "............................................................................................",

  DEVICE_WITH_LOST_IP_DOTS: ".........................................................................................",

  DISCLAIMER_EXPERT_DOTS: ".................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2: "....................................................................................................................................",

  OVERVIEW_DOTS: ".................................................................................................................................",
  LIVE_LIST_DOTS: "......................................................................................................................................",
  INVENTORY_DOTS: "...................................................................................................................................",
  TOPOLOGY_DOTS: "...................................................................................................................................",
  IN_TRAFFIC_ERRORS_DOTS: "......................................................................................................",
  OUT_TRAFFIC_ERRORS_DOTS: "..........................................................................................................",
  MON_LOG_DOTS: "..............................................................................................................................................",
  DISCLAIMER_DOTS: "..................................................................................................................................",
  DISCLAIMER_DOTS_2: ".....................................................................................................................................",

  ADD_ALTER_TAGS: "Adicionar/Alterar Tags",
  CHANGE_TAG_FAILURE: "Ocorreu um erro ao alterar a tag",
  CHANGE_TAG_SUCCESS: "A tag foi alterada com sucesso.",
  CHOOSE_DEVICE: "Escolha um dispositivo",
  CONFIRM_REMOVE_ALL_TAGS: "Tem certeza que deseja remover as tags de todos os dispositivos?",
  EXPORT_TAGS: "Exportar tags",
  IMPORT_TAGS: "Importar tags",
  IMPORT_TAGS_FAILURE: "Ocorreu um erro ao importar as tags: ",
  IMPORT_TAGS_SUCCESS: "As tags foram importadas com sucesso",
  NEW_TAG: "Nova TAG",
  N_REASON_DP: "\nMotivo: ",
  PLEASE_SELECT_DEVICE: "Por favor selecione um dispositivo.",
  PLEASE_SELECT_TAG_FILE: "Por favor selecione um arquivo de tags.",
  REMOVE: "Remover",
  REMOVE_ALL_TAGS: "Remover todas as Tags",
  REMOVE_TAG_FAILURE: "Ocorreu um erro ao remover as tags",
  REMOVE_TAG_SUCCESS: "As tags foram removidas com sucesso.",
  TAGS: "Tags dos dispositivos",
  ACTIVE_COLUMNS: "Colunas ativas",

  // PRO topology compatibility
  ACCESS_POINT: "Access Point",
  ADD: "Adicionar",
  ADD_DEVICE: "Adicionar dispositivo",
  ALERT_AUTO_DETECTED_CONNECTIONS_CANNOT_BE_REMOVED: "Não é permitido remover conexões detectadas automaticamente.",
  ALERT_CHOOSE_DEVICE_TYPE: "Por favor escolha um tipo de dispositivo",
  ALERT_MANUAL_CONNECTION_CREATION_FAILED: "Não foi possível criar a conexão manual.",
  ALERT_ONLY_MANUAL_CONNECTIONS_CAN_BE_REMOVED: "Apenas conexões criadas manualmente podem ser removidas.",
  ALERT_ONLY_MANUAL_DEVICES_CAN_BE_EDITED: "Apenas devices criados manualmente podem ser editados.",
  ALERT_ONLY_MANUAL_DEVICES_CAN_BE_REMOVED: "Apenas devices criados manualmente podem ser removidos.",
  ALERT_SELECT_DIFFERENT_DEVICES_FOR_CONNECTION: "Selecione dois devices diferentes para criar uma conexão.",
  CANCEL: "Cancelar",
  CHOOSE_A_DEVICE: "Escolha um dispositivo para visualizar suas informações",
  CURRENT_JITTER: "Jitter atual",
  CURRENT_PING: "Ping atual",
  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Escolha um tipo de dispositivo",
  ENDPOINT: "Endpoint",
  FIREWALL: "Firewall",
  GRAPHIC_TOPOLOGY_ADD_REGION: "Adicionar região",
  GRAPHIC_TOPOLOGY_CANCEL_REGION_DRAWING: "Cancelar demarcação",
  GRAPHIC_TOPOLOGY_DEFAULT_REGION_NAME: "Planta",
  GRAPHIC_TOPOLOGY_DEVICES: "Devices",
  GRAPHIC_TOPOLOGY_DEVICES_LOWERCASE: "devices",
  GRAPHIC_TOPOLOGY_DEVICE_TAB: "Device",
  GRAPHIC_TOPOLOGY_DISPLAY_CONFIG_SAVED: "Configurações de exibição salvas com sucesso.",
  GRAPHIC_TOPOLOGY_DISPLAY_CONFIG_SAVE_ERROR: "Não foi possível salvar as configurações de exibição.",
  GRAPHIC_TOPOLOGY_DISPLAY_HELP: "Escolha quais informações aparecem abaixo dos devices automáticos.",
  GRAPHIC_TOPOLOGY_DISPLAY_TAB: "Exibição",
  GRAPHIC_TOPOLOGY_DRAW_REGION_INSTRUCTION: "Clique e arraste na topologia para desenhar a região. Solte o mouse para informar o nome.",
  GRAPHIC_TOPOLOGY_EDIT_REGION: "Editar região",
  GRAPHIC_TOPOLOGY_FILES_HELP: "Exporte a topologia ou importe um arquivo JSON salvo anteriormente.",
  GRAPHIC_TOPOLOGY_FILES_TAB: "Arquivos",
  GRAPHIC_TOPOLOGY_MANUAL_CONNECTION: "Conexão manual",
  GRAPHIC_TOPOLOGY_MANUAL_DEVICES: "Adicionados",
  GRAPHIC_TOPOLOGY_NEW_REGION: "Nova região",
  GRAPHIC_TOPOLOGY_POSITION_HELP: "Edite, salve ou remova as posições atuais dos devices e regiões.",
  GRAPHIC_TOPOLOGY_POSITION_TAB: "Posição",
  GRAPHIC_TOPOLOGY_REGIONS: "Regiões",
  GRAPHIC_TOPOLOGY_REGIONS_HELP: "Crie áreas da planta e ajuste cada região diretamente no canvas.",
  GRAPHIC_TOPOLOGY_REGIONS_LOWERCASE: "regiões",
  GRAPHIC_TOPOLOGY_REGIONS_TAB: "Regiões",
  GRAPHIC_TOPOLOGY_REGION_NAME: "Nome da região",
  GRAPHIC_TOPOLOGY_REGION_NAME_PLACEHOLDER: "Ex: Planta-1",
  GRAPHIC_TOPOLOGY_REGION_NAME_REQUIRED: "Informe o nome da região.",
  GRAPHIC_TOPOLOGY_REMOVE_REGION: "Remover região",
  GRAPHIC_TOPOLOGY_SEARCH_EMPTY: "Digite um IP, Tag ou profiname para pesquisar.",
  GRAPHIC_TOPOLOGY_SEARCH_NOT_FOUND_1: "Nenhum device encontrado para: ",
  GRAPHIC_TOPOLOGY_SEARCH_NOT_FOUND_2: ".",
  GRAPHIC_TOPOLOGY_SELECTED_REGION_PLACEHOLDER: "Região selecionada",
  GRAPHIC_TOPOLOGY_SELECT_REGION_TO_EDIT: "Selecione uma região para editar.",
  GRAPHIC_TOPOLOGY_SELECT_REGION_TO_REMOVE: "Selecione uma região para remover.",
  GRAPHIC_TOPOLOGY_SHOW_IP: "Mostrar IP",
  GRAPHIC_TOPOLOGY_SHOW_PROFINAME: "Mostrar profiname",
  GRAPHIC_TOPOLOGY_SHOW_TAG: "Mostrar Tag",
  GRAPHIC_TOPOLOGY_SUBTITLE: "Organize devices, conexões e regiões da planta",
  GRAPHIC_TOPOLOGY_TITLE: "Topologia gráfica",
  HAS_TS_EXPERT_EVENT: "Possui evento no TS Expert?",
  HMI: "HMI",
  IP_PLACEHOLDER: "IP (Opcional)",
  LOCALE_ADD_DESCRIPTION: "Clique em um espaço em branco para adicionar um novo dispositivo",
  LOCALE_ADD_EDGE: "Adicionar conexão",
  LOCALE_ADD_NODE: "Adicionar dispositivo",
  LOCALE_BACK: "Voltar",
  LOCALE_CREATE_EDGE_ERROR: "Não é possível criar conexão para um cluster",
  LOCALE_DEL: "Remover selecionado",
  LOCALE_DELETE_CLUSTER_ERROR: "Clusters não podem ser removidos",
  LOCALE_EDGE_DESCRIPTION: "Clique em um dispositivo e arraste a conexão até outro dispositivo para conectá-los",
  LOCALE_EDIT: "Editar",
  LOCALE_EDIT_CLUSTER_ERROR: "Clusters não podem ser editados",
  LOCALE_EDIT_EDGE: "Editar conexão",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Clique nos pontos de controle e os arraste para um dispositivo para conectá-los",
  LOCALE_EDIT_NODE: "Editar dispositivo",
  MAX_JITTER: "Jitter máximo",
  MAX_PING: "Ping máximo",
  NO_DEVICE_SELECTED: "Nenhum dispositivo selecionado",
  OPEN_DEVICE_IN_GRAPHIC_TOPOLOGY: "Abrir este device na Topologia Gráfica",
  PC: "Notebook",
  PS_2: "OBS2:",
  PS_3: "OBS3:",
  SELECTED_DEVICE: "Dispositivo selecionado",
  SERVER: "Servidor",
  SWITCH: "Switch",
  TABLE_TOPOLOGY: "Topologia em tabela",
  TAG_PLACEHOLDER: "TAG",
  TAP: "TAP",
  TOPOLOGY_CSV_EXPORT_NAME: "Topologia.xlsx",
  TOPOLOGY_CSV_HEADER: "SNMP,Nome,Modelo,IP,Porta,Nome do vizinho,Porta do vizinho,IP do vizinho\n",
  UNIQUE_DROPPED: "Dropped packets únicos",
  TS_EXPERT_SMART_DIAGNOSIS: "Diagnóstico inteligente PROFINET",
  TS_EXPERT_EVENT_TYPES: "Tipos de eventos",
  TS_EXPERT_OCCURRENCES: "Ocorrências",
  TRAFFIC_CSV_HEADER: "IP,Nome,Tempo ligado,Nome da porta,Modo Duplex,Delay,Velocidade da interface,Tráfego de entrada (Kbps),Erros nos pacotes de entrada,Tráfego de saída (Kbps),Erros nos pacotes de saída,Status da porta\n",
  TRAFFIC_CSV_EXPORT_NAME: "Tráfego.xlsx",
});

export default Strings;